import { StyleRules } from '@material-ui/core/styles';
import { AccordionClassKey } from '@material-ui/core/Accordion';

import { core as theme } from '../styles/core';

export const MuiAccordion: Partial<StyleRules<AccordionClassKey>> = {
  root: {
    borderTop: `1px solid ${theme.palette.grey.A400}`,
    boxShadow: 'none',
    '&::before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 0,
    },
  },
};
